<template>
<div class="item">
    <div class="item__indicator">
        <i  class="material-icons lamp"
            :class="item.type"
        >
            {{item.type}}
        </i>
    </div>
    <div class="item__body">
        <div class="item__body__title">
            <p class="action">
                {{ titleLabelTranslation }}
            </p>
            <p class="time">
                {{humanizeTime(item.timestamp)}}
            </p>
        </div>
        <p class="description">
            {{ $t(item.msgLabel) }}
        </p>
    </div>
</div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    item: Object
  },

  methods: {
    humanizeTime (stamp) {
      return moment(stamp).format('LTS')
    }
  },

  computed: {
    titleLabelTranslation () {
      const titleLabel = this.item.titleLabel
      if (Array.isArray(titleLabel)) {
        return this.$t(...titleLabel)
      }
      return this.$t(titleLabel)
    }
  }
}
</script>

<style lang="scss" scoped>
    .item {
        display: flex;
        width: 100%;
        padding: 0 16px;
        margin-bottom: 16px;

        &__indicator {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            width: 32px;
            padding-top: 2px;

            .lamp {
                font-size: 16px;

                &.info      { color: $or-blue; }
                &.warning   { color: $or-yellow; }
                &.error     { color: $or-red; }
            }
        }

        &__body {
            display: flex;
            flex-direction: column;
            width: calc(100% - 32px);

            &__title {
                display: flex;
                align-items: baseline;

                .action {
                    width: calc(100% - 80px);
                    margin: 0 0 2px;
                    flex-grow: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 14px;
                }

                .time {
                    width: 80px;
                    text-align: right;
                    margin: 0;
                    flex-grow: 0;
                    font-size: 12px;
                    color: $or-grey-dark;
                }
            }

            .description {
                font-size: 12px;
                line-height: 16px;
                color: $or-grey-dark;
                margin: 0;
            }
        }
    }
</style>
